module.exports = __webpack_public_path__ + "img/icon_bg2.06a0bdca.png";